"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SurveyUtil = void 0;
var _SmartColor = _interopRequireDefault(require("../models/SmartColor"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable import/prefer-default-export */
var smartColor = new _SmartColor["default"]();
var SurveyUtil = exports.SurveyUtil = /*#__PURE__*/_createClass(function SurveyUtil() {
  _classCallCheck(this, SurveyUtil);
});
_defineProperty(SurveyUtil, "generateSurveyChartData", function (question) {
  var submissions = question.submissions,
    answers = question.answers,
    answersPercentage = question.answersPercentage;
  var pctg = 0;
  var res = Object.values(answers).map(function (answer, i) {
    // in some cases, the percentages are already calculated
    if (answersPercentage) {
      pctg = parseFloat(answersPercentage[answer.id].replace('%', ''), 10);
    } else {
      var _answer$count = answer.count,
        count = _answer$count === void 0 ? 0 : _answer$count;
      pctg = Math.round(((count / submissions || 0) * 100 + Number.EPSILON) * 100) / 100;
    }
    return _objectSpread(_objectSpread({}, answer), {}, {
      submissionCount: submissions && submissions.length || 0,
      submissionPercentage: pctg,
      color: smartColor.getSmartColor(i + 1)
    });
  });
  return res;
});
_defineProperty(SurveyUtil, "getSurveyChartOptions", function (data) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var chart = opts.chart,
    title = opts.title,
    tooltip = opts.tooltip,
    _opts$plotOptions = opts.plotOptions,
    plotOptions = _opts$plotOptions === void 0 ? {} : _opts$plotOptions,
    _opts$plotOptions2 = opts.plotOptions,
    _opts$plotOptions3 = _opts$plotOptions2 === void 0 ? {} : _opts$plotOptions2,
    pie = _opts$plotOptions3.pie,
    _opts$point = opts.point,
    point = _opts$point === void 0 ? {} : _opts$point,
    accessibility = opts.accessibility,
    series = opts.series,
    credits = opts.credits;
  return {
    chart: _objectSpread({
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie'
    }, chart),
    title: _objectSpread({
      text: null
    }, title),
    tooltip: _objectSpread({
      pointFormat: '{series.name}: <b>{point.y}%</b>'
    }, tooltip),
    accessibility: _objectSpread({
      point: _objectSpread({
        valueSuffix: '%'
      }, point)
    }, accessibility),
    plotOptions: _objectSpread({
      pie: _objectSpread({
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false
        }
      }, pie)
    }, plotOptions),
    series: [_objectSpread({
      name: 'Answers',
      colorByPoint: true,
      data: data
    }, series)],
    credits: _objectSpread({
      enabled: false
    }, credits)
  };
});